import { defineSlotRecipe } from '@chakra-ui/react';
export const datePickerRecipe = defineSlotRecipe({
    className: 'datePicker',
    slots: [
        'label',
        'group',
        'dateInput',
        'dateSegment',
        'button',
        'buttonIcon',
        'popover',
        'dialog',
        'calendar',
        'calendarHeader',
        'calendarGrid',
        'calendarHeaderCell',
        'calendarCell',
        'errorText',
        'dateInputPlaceholder',
    ], // Keep slots as an array of names
    base: {
        // Define styles for each slot under base
        label: {
            display: 'block',
            fontSize: 'sm',
            fontWeight: 'medium',
            color: 'gray.700',
            mb: 1,
        },
        group: {
            display: 'flex',
            alignItems: 'center',
            border: '1px solid',
            borderColor: 'border',
            borderRadius: 'lg',
            p: 3,
            bg: 'white',
            cursor: 'text',
            transition: 'border-color 0.2s',
            _hover: { borderColor: 'border.emphasized' },
            _focusWithin: {
                borderColor: 'primary.500',
                boxShadow: '0 0 0 1px var(--chakra-colors-primary-500)',
            },
            _invalid: { borderColor: 'red.500' },
            _disabled: { bg: 'gray.50', cursor: 'not-allowed', opacity: 0.6 },
        },
        dateInput: {
            flex: 1,
            display: 'flex',
            fontSize: '15px',
            fontWeight: 'medium',
            color: 'gray.900',
        },
        dateInputPlaceholder: {
            color: 'gray.500',
            fontSize: '13px',
            fontWeight: 'medium',
        },
        dateSegment: {
            px: '1px',
            borderRadius: 'sm',
            caretColor: 'transparent',
            _focus: { bg: 'primary.500', color: 'white', outline: 'none' },
            '&[data-placeholder=true]': { color: 'gray.400' },
        },
        button: {
            ml: 2,
            w: '2.25rem',
            h: '2.25rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bg: 'gray.100',
            border: 'none',
            borderRadius: 'md',
            color: 'gray.600',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            _disabled: { color: 'gray.300' },
            _hover: { bg: 'gray.200' },
        },
        buttonIcon: {
            width: '1rem',
            height: '1rem',
            color: 'inherit',
        },
        popover: {
            bg: 'white',
            borderRadius: 'lg',
            border: '1px solid',
            borderColor: 'border',
            mt: 1,
            zIndex: 10,
        },
        dialog: {
            outline: 'none',
            p: 3,
        },
        calendar: {},
        calendarHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            px: 1,
            '& > heading': {
                fontSize: 'md',
                fontWeight: 'medium',
                color: 'gray.700',
            },
            '& > button': {
                borderRadius: 'md',
                p: 1,
                _hover: { bg: 'gray.100' },
                _focusVisible: { outline: '2px solid token(colors.primary.500)', outlineOffset: '1px' },
            },
        },
        calendarGrid: {},
        calendarHeaderCell: {
            textAlign: 'center',
            fontSize: 'sm',
            color: 'gray.500',
            fontWeight: 'medium',
            pb: 1,
        },
        calendarCell: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: '2.25rem',
            borderRadius: 'md',
            cursor: 'default',
            textAlign: 'center',
            fontSize: 'sm',
            border: '1px solid',
            borderColor: 'transparent',
            outline: 'none',
            _hover: { bg: 'gray.100' },
            _disabled: { color: 'gray.300', cursor: 'not-allowed', _hover: { bg: 'transparent' } },
            _selected: { bg: 'primary.500', color: 'white', _hover: { bg: 'primary.600' } },
            '&[data-unavailable]': {
                color: 'gray.300',
                textDecoration: 'line-through',
                _hover: { bg: 'transparent' },
            },
            _invalid: { bg: 'red.100', color: 'red.800', _hover: { bg: 'red.200' } },
            _focusVisible: { outline: '2px solid token(colors.primary.500)', outlineOffset: '1px' },
            '&[data-today]': { fontWeight: 'semibold', borderColor: 'primary.400' },
            '&[data-selected][data-today]': { borderColor: 'primary.700' },
        },
        errorText: {
            color: 'red.500',
            fontSize: 'sm',
            mt: 1,
        },
    },
    variants: {
        colorPalette: {
            primary: {
                group: {
                    _focusWithin: {
                        borderColor: 'primary.500',
                        boxShadow: '0 0 0 1px var(--chakra-colors-primary-500)',
                    },
                },
                dateSegment: {
                    _focus: { bg: 'primary.500', color: 'white', outline: 'none' },
                },
                // button: {
                //   color: 'gray.900',
                // },
                calendarHeader: {
                    '& > button': {
                        _focusVisible: { outline: '2px solid token(colors.primary.500)', outlineOffset: '1px' },
                    },
                },
                calendarCell: {
                    _selected: { bg: 'primary.500', color: 'white', _hover: { bg: 'primary.600' } },
                    _focusVisible: { outline: '2px solid token(colors.primary.500)', outlineOffset: '1px' },
                    '&[data-today]': { borderColor: 'primary.400' },
                    '&[data-selected][data-today]': { borderColor: 'primary.700' },
                },
            },
        },
        size: {
            md: {
            // You can add size-specific styles if needed
            },
        },
    },
    defaultVariants: {
        colorPalette: 'primary',
        size: 'md',
    },
});
